module.exports = __webpack_public_path__ + "static/profile-ben-45ace619903517911910a276cce91410.jpg";